import React, { useEffect, useState } from "react";
import { CommandDialog, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem } from "@/components/ui/command";
import { useStore } from "@/lib/store";
import { searchSuggest } from "@/lib/api";
import { useNavigate } from "react-router-dom";

export function PredictiveSearch() {
  const { searchOpen, setSearchOpen } = useStore();
  const [q, setQ] = useState("");
  const [results, setResults] = useState({ fragrances: [], notes: [], inspired_by: [] });
  const navigate = useNavigate();

  useEffect(() => {
    if (!q || q.length < 1) { setResults({ fragrances: [], notes: [], inspired_by: [] }); return; }
    const t = setTimeout(() => {
      searchSuggest(q).then(setResults).catch(() => {});
    }, 140);
    return () => clearTimeout(t);
  }, [q]);

  const go = (slug) => {
    setSearchOpen(false);
    setQ("");
    navigate(`/product/${slug}`);
  };

  const goShopFiltered = (filterType, filterValue) => {
    setSearchOpen(false);
    setQ("");
    const key = filterType === "note" ? "note" : "inspired_by";
    navigate(`/shop?${key}=${encodeURIComponent(filterValue)}`);
  };

  return (
    <CommandDialog open={searchOpen} onOpenChange={setSearchOpen}>
      <CommandInput
        placeholder="Search fragrances, notes, or 'inspired by'..."
        value={q}
        onValueChange={setQ}
        data-testid="search-input"
      />
      <CommandList>
        <CommandEmpty>Try "Vanilla", "Baccarat", "Oud"</CommandEmpty>
        {results.fragrances.length > 0 && (
          <CommandGroup heading="Fragrances">
            {results.fragrances.map((f) => (
              <CommandItem key={f.id} onSelect={() => go(f.slug)} data-testid={`search-result-fragrance-${f.slug}`}>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-10 rounded bg-[#F1ECE4]" style={{ backgroundImage: `url(${f.image_url})`, backgroundSize: "cover", backgroundPosition: "center" }} />
                  <div>
                    <div className="text-[10px] uppercase tracking-[0.16em] text-[#1A1918]/60">{f.number}</div>
                    <div className="font-serif">{f.name}</div>
                  </div>
                </div>
              </CommandItem>
            ))}
          </CommandGroup>
        )}
        {results.notes.length > 0 && (
          <CommandGroup heading="Notes">
            {results.notes.map((n) => (
              <CommandItem key={n.name} onSelect={() => goShopFiltered("note", n.name)} data-testid={`search-result-note-${n.name.replace(/\s+/g, '-').toLowerCase()}`}>
                {n.name}
              </CommandItem>
            ))}
          </CommandGroup>
        )}
        {results.inspired_by.length > 0 && (
          <CommandGroup heading="Inspired By">
            {results.inspired_by.map((i) => (
              <CommandItem key={i.name} onSelect={() => goShopFiltered("inspired_by", i.name)} data-testid={`search-result-inspired-${i.name.replace(/\s+/g, '-').toLowerCase()}`}>
                Inspired by {i.name}
              </CommandItem>
            ))}
          </CommandGroup>
        )}
      </CommandList>
    </CommandDialog>
  );
}

export default PredictiveSearch;
